<template>
    <div>
        <div class="offcanvas offcanvas-end" style="width:85%; font-family: 'Exo 2', sans-serif !important;"
            tabindex="-1" id="offcanvasExample2" aria-labelledby="offcanvasExampleLabel2"
            :style="skin.header_mobil.nav_bar_text">
            <div class="mx-0 text-end p-2" :style="skin.side_bar.header + skin.side_bar.header_text"
                style="align-items: right;">
                <button id="closeSideBar" type="button" class="btn btn-sm text-reset" data-bs-dismiss="offcanvas"
                    aria-label="Close">
                    <span style="color:white;font-size:large;"><i class="fa fa-times"></i></span>
                </button>
            </div>
            <div class="offcanvas-body p-2" :style="skin.side_bar.body" style="position: relative;">
                <div class="d-flex" v-if="user.token != '' && skin.header_mobil.balance" data-bs-toggle="modal"
                    data-bs-target="#historial_ingresos" @click="closeSideBar">
                    <div class="user-info mx-1">
                        <div class="avatar px-2 py-1 pb-0">
                            <i class="fa fa-user"></i>
                        </div>
                    </div>
                    <div class="m-0 p-0 text-start" style="font-size: small;">
                        <span style="color:white;">{{ user.user_data.data ? user.user_data.data.user_name : '' }}</span>
                        <br>
                        <span @click="showBalanceAction" style="color:white;">{{ user.user_data.data ? new
                            Intl.NumberFormat("de-DE", {
                                minimumFractionDigits:
                                    skin.qBet_config.decimalsQty, maximumFractionDigits:
                                    skin.qBet_config.decimalsQty
                            }).format(balance.saldo) : 0 }}</span>
                    </div>
                </div>
                <div v-if="user.token != ''" class="d-flex align-items-center">
                    <table class="table table-striped custom-table">
                        <tr>
                            
                            <td style="text-align:center;" @click="closeSideBar">
                                <a style="color:white;" v-if="skin.header_desktop.userMenu.balanceHistory"
                                    @click="getMovements()" data-bs-toggle="modal" data-bs-target="#myAccountZeus"
                                    class="dropdown-item" href="#"><i class="fa fa-history"></i> {{ translate('history')
                                    }}</a>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align:center;" @click="closeSideBar">
                                <a style="color:white;"
                                    v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.changePassword"
                                    id="changePasswordBtn" data-bs-toggle="modal" data-bs-target="#changePasswordJm"
                                    class="dropdown-item" href="#"><i class="fa fa-key"></i> {{ translate('password')
                                    }}</a>
                            </td>
                            <td style="text-align:center;" @click="closeSideBar">
                                <a style="color:white;" v-if="skin.header_desktop.userMenu.sportsRules" @click="terms"
                                    class="dropdown-item" href="#"><i class="fa fa-book"></i> {{
                                    translate('regulations') }}</a>
                            </td>
                        </tr>
                    </table>
                </div>


                <div v-for="(item, index) in filteredCategories" :key="index" @click="change_view(index)"
                    :class="{ 'py-3': true, 'table-striped': index % 2 == 0 }">
                    <div class="d-flex" :id="'item-' + index">
                        <img :src="item.icon" class="me-1" style="width:36px;height:36px;max-height: 22px ">
                        &nbsp;&nbsp;<span style="text-transform: uppercase;" :style="skin.side_bar.navigation_text">{{
                            translate(item.name) }}</span>
                    </div>
                </div>
                <div v-if="user.token != ''" style="position: absolute;bottom: 10px;" class="">
                    <a v-if="skin.logout" @click="logout" class="dropdown-item my-2" href="#" style="color:white"><i
                            class="fa fa-power-off fa-inverse"></i> {{ translate('go_out') }}</a>
                </div>
            </div>
        </div>
        <div class="modal fade" id="limitModal" tabindex="-1" aria-labelledby="limitModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="background-color: #1c1c1c;" :style="skin.header_desktop.nav_bar_text">
                    <div class="modal-header">
                        <h5 class="modal-title" id="limitModalLabel">{{ translate('max_lim') }}</h5>
                        <button type="button" style="background-color: #fff;" class="btn-close btn-outline-light"
                            data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body" style="background-color: #1c1c1c; font-size: 16px;">
                        <div class="text-center">
                            <span>• {{ translate('max_lim') }} •</span>
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">PragmaticPlay</span>
                            <span style="width:50%;text-align: right;">160.000</span>
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">VivoGaming</span>
                            <span style="width:50%;text-align: right;">160.000</span>
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">Ezugi</span>
                            <span style="width:50%;text-align: right;">160.000</span>
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">Caballos</span>
                            <span style="width:50%;text-align: right;">160.000</span>
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">Slots</span>
                            <span style="width:50%;text-align: right;">8.000</span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <span style="font-size: small;">• {{ translate('condition') }}.</span>
                    </div>
                </div>
            </div>
        </div>
        <myAccountJM v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />

    </div>
</template>

<script>
import axios from 'axios';
import myAccountJM from "../../header/my_account.vue";
import languageSelector from '../../header/language.vue';
export default {
    name: 'Sidebar',
    components: {
        languageSelector,
        myAccountJM
    },
    props: ['translation', 'language'],
    data() {
        return {
            userDataLoaded: false,
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
            showBalance: false
        }
    },
    computed: {
        filteredCategories() {
            return this.skin.categories.filter(category => category.active);
        },
        favoritos() {
            return this.$store.getters['live/getFavorites'];
        },
        sports() {
            return this.$store.getters['live/getSports'];
        },
        skin() {
            return this.$store.getters['getCurrentSkin'];
        },
        user() {
            return this.$store.getters['getUserData'];
        },
        user_demo() {
            let data = this.$store.getters['getUserDataDemo'];
            return data;
        },
        prematchTarget() {
            return this.$store.getters['getPrematchTarget'];
        },
        time2() {
            return this.$store.getters['prematch_2/getTime'];
        },
        timeLoading() {
            return this.$store.getters['prematch_2/getTimeLoading'];
        },
        sports_prematch() {
            return this.$store.getters['prematch_2/getSports'];
        },
        nav_activeCss() {
            return {
                '--bar': this.skin.side_bar.nav_active_bar,
                '--text': this.skin.side_bar.nav_active_text,
            }
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },

        config() {
            return this.$store.getters['getConfig'];
        },
    },
    methods: {
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        async getSupportTickets() {
            let tickets = await axios.post("https://reportes." + this.user.domain.split("admin.")[1] + "/estado_soporte", {
                "login_Id": this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                site_url: "https://reportes." + this.user.domain.split("admin.")[1]
            })
            if (tickets.data) {
                this.supportTickets = tickets.data;
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
            document.getElementById('closeSideBar').click();
        },
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
        active: function (id) {
            let items = document.getElementsByClassName("item-menu");
            [...items].forEach(item => {
                item.classList.remove('nav_active1');
                item.classList.remove('active');
            });
            document.getElementById(id).classList.add('nav_active1');
            document.getElementById(id).classList.add('active');
        },
        check_booking() {
            if (this.booking_code != '') {
                this.$store.dispatch('getBooking', this.booking_code);
            }
            else {
                this.alert.message = this.translate('Ingresa un código de reserva válido');
                this.alert.type = 'danger';
                this.alert.active = true;
                setTimeout(this.alert_off, 5000);
            }
        },
        change_view(view) {
            document.getElementById('closeSideBar').click();
            this.$store.dispatch("changeView", view);
        },
        closeSideBar() {
            document.getElementById('closeSideBar').click();
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },

    },
    watch: {
        userDataLoaded(newVal, oldVal) {
            if (newVal != oldVal && newVal) {
                this.getSupportTickets();
            }
        },
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-group2 {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}

.nav_active1 {
    color: var(--text);
    border-bottom: var(--bar);
}

.table-striped {
    background-color: #020f1d;
}

.custom-table {
    color: white;
    border-radius: 20px;
    font-size: 12px;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    /* Separar los bordes de las celdas */
    border-spacing: 5px;
    /* Espaciado entre celdas */
    width: 100%;
}

.custom-table th,
.custom-table td {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 2px;
    /* Ajusta el espaciado interno de las celdas */
    text-align: center;
}

.custom-table th {
    background-color: #333;
    color: white;
}

.offcanvas-body .p-2:hover {
    background-color: #444444 !important;
}

.avatar {
    width: 38px;
    height: 38px;
    border-radius: 6px;
    text-align: center;
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
    background: #1c1c1c;
    border: 1px solid #fff;
    font-size: 1.6rem !important;
    vertical-align: middle;
    color: #fff;
    padding-top: 5px;
}
</style>import { head } from 'lodash';
